$(document).ready(function () {
  if ($(".c-guidelines-accordion").length > 0) {
    // scope of current accordion
    $(".c-guidelines-accordion").each(function (e) {
      // clicking on accordion-toggle
      var accordionTriggers = $(this).find(
        ".c-guidelines-accordion-item__tease"
      );

      accordionTriggers.on("click", function (e) {
        //Expand or collapse this panel
        if ($(this).hasClass("open")) {
          $(this).removeClass("open");
          $(this).children(".c-guidelines-accordion-item__tease .c-guidelines-accordion-arrow").removeClass("open");
          $(this).children(".c-guidelines-accordion-item__tease .c-guidelines-accordion-plus").removeClass("open");
          $(this)
            .siblings(".c-guidelines-accordion-item__content-wrapper")
            .slideUp("fast");
        } else {
          $(this).addClass("open");
          $(this).children(".c-guidelines-accordion-item__tease .c-guidelines-accordion-arrow").addClass("open");
          $(this).children(".c-guidelines-accordion-item__tease .c-guidelines-accordion-plus").addClass("open");
          $(this)
            .siblings(".c-guidelines-accordion-item__content-wrapper")
            .slideDown("fast");
        }
      });
    });

    $(".c-guidelines-accordion__expand").on("click", function (e) {
      console.log("expand");
      var siblings = $(this).siblings(".c-guidelines-accordion-item");

      console.log("siblings", siblings);

      if ($(this).hasClass("open")) {
        $(this).removeClass("open");
        $(this).text("Expand All");

        siblings.each(function (e) {
          $(this).find(".c-guidelines-accordion-arrow").removeClass("open");
          $(this).find(".c-guidelines-accordion-plus").removeClass("open");
          $(this)
            .children(".c-guidelines-accordion-item__tease")
            .removeClass("open");
          $(this)
            .children(".c-guidelines-accordion-item__content-wrapper")
            .slideUp("fast");
        });
        //each
      } else {
        $(this).addClass("open");
        $(this).text("Collapse All");

        siblings.each(function (e) {
          $(this).find(".c-guidelines-accordion-arrow").addClass("open");
          $(this).find(".c-guidelines-accordion-plus").addClass("open");
          $(this)
            .children(".c-guidelines-accordion-item__tease")
            .addClass("open");
          $(this)
            .children(".c-guidelines-accordion-item__content-wrapper")
            .slideDown("fast");
          $(this);
        });
        //each
      }
    });
  }

  var hashValue = window.location.hash.substring(1); // remove #

  if (hashValue) {
    var escapedHash = $.escapeSelector(hashValue); // escape +, spaces, etc.

    let item = $(
      '.c-guidelines-accordion-item[data-id="' + escapedHash + '"] .c-guidelines-accordion-item__tease'
    );

    // check it exists before scrolling
    if (item.length) {

      $("html, body").animate({
        scrollTop: parseInt($(item).offset().top),
      });
    
      $(item).addClass("open");
      $(item)
        .children(
          ".c-guidelines-accordion-item__tease .c-guidelines-accordion-arrow"
        )
        .addClass("open");
      $(item)
        .siblings(".c-guidelines-accordion-item__content-wrapper")
        .slideDown("fast");
    }
  }

});
